// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"12ae0fba","341":"a420a3a5","447":"0e084233","488":"a84b7f07","583":"098fd020","722":"88df53f6","954":"69b1ce1a"}[chunkId] + ".chunk.js";
};